import { Button } from "./Button";
export function LockState({ outcome, plan }: { outcome: string; plan: "Pro"|"Team"|"Enterprise" }) {
  return <section className="pz-lock" aria-labelledby="lock-title">
    <span aria-hidden="true">⌁</span><h1 id="lock-title">{outcome}</h1>
    <p>This capability is available on the {plan} plan. Your current data is unchanged.</p>
    <div><Button href="/billing">Compare plans</Button> <Button href="/live" variant="secondary">Return to live view</Button></div>
  </section>;
}
